import React from "react"
import Paper from "@mui/material/Paper";
import {Box, Divider, Table, TableBody, TableCell, TableContainer, TableRow} from "@mui/material";
import {DEFAULT_LOCALE, INR_CURRENCY_STYLE} from "../util/constant";
import {Typography} from "@material-ui/core";

const HoldingSummary = ({
                            firstBought,
                            totalAmount,
                            holding,
                            cash,
                            unRealizedProfitOrLossAmount,
                            realizedProfitOrLossAmount,
                            totalProfitOrLossAmount,
                            marktScore,
                            classes
                        }) => {
    return (
        <Paper elevation={2}>
            <Box display="flex" justifyContent="space-between" m={1}>
                <Box component="span" display="flex" flexDirection="column">
                    <Typography variant="caption" align="center">Start Date</Typography>
                    <Typography variant="subtitle2">{firstBought}</Typography>
                </Box>
                <Box component="span" display="flex" flexDirection="column">
                    <Typography variant="caption" align="center">Invested</Typography>
                    <Typography
                        variant="subtitle2">{totalAmount?.toLocaleString(DEFAULT_LOCALE, INR_CURRENCY_STYLE)}</Typography>
                </Box>
                <Box component="span" display="flex" flexDirection="column">
                    <Typography variant="caption" align="center">Market Score</Typography>
                    <Typography variant="subtitle2" className={classes.marketScore}
                                align="center">{marktScore}</Typography>
                </Box>
            </Box>
            <Divider/>
            <Box display="flex" justifyContent="space-between" m={1}>
                <Box component="span" display="flex" flexDirection="column">
                    <Typography variant="caption" align="center">Market Holding</Typography>
                    <Typography
                        variant="subtitle2">{holding?.toLocaleString(DEFAULT_LOCALE, INR_CURRENCY_STYLE)}</Typography>
                </Box>
                <Box component="span" display="flex" flexDirection="column">
                    <Typography variant="caption" align="center">Cash</Typography>
                    <Typography
                        variant="subtitle2">{cash?.toLocaleString(DEFAULT_LOCALE, INR_CURRENCY_STYLE)}</Typography>
                </Box>
                <Box component="span" display="flex" flexDirection="column">
                    <Typography variant="caption" align="center">Total Amount</Typography>
                    <Typography
                        variant="subtitle2">{(holding + cash)?.toLocaleString(DEFAULT_LOCALE, INR_CURRENCY_STYLE)}</Typography>
                </Box>
            </Box>
            <Divider/>
            <Box display="flex" justifyContent="space-between" m={1}>
                <Box component="span" display="flex" flexDirection="column">
                    <Typography variant="caption" align="center">Unrealized</Typography>
                    <Typography variant="subtitle2" align="center"
                                className={unRealizedProfitOrLossAmount > 0 ? classes.profit : classes.loss}>
                        {unRealizedProfitOrLossAmount?.toLocaleString(DEFAULT_LOCALE, INR_CURRENCY_STYLE)}
                    </Typography>
                    <Typography variant="subtitle2"
                                className={unRealizedProfitOrLossAmount > 0 ? classes.profit : classes.loss}
                                align="center">
                        ({(unRealizedProfitOrLossAmount * 100 / totalAmount).toFixed(2)}%)
                    </Typography>
                </Box>
                <Box component="span" display="flex" flexDirection="column">
                    <Typography variant="caption" align="center">Realized</Typography>
                    <Typography variant="subtitle2" align="center"
                                className={realizedProfitOrLossAmount > 0 ? classes.profit : classes.loss}>
                        {realizedProfitOrLossAmount?.toLocaleString(DEFAULT_LOCALE, INR_CURRENCY_STYLE)}</Typography>
                    <Typography variant="subtitle2"
                                className={realizedProfitOrLossAmount > 0 ? classes.profit : classes.loss}
                                align="center">
                        ({(realizedProfitOrLossAmount * 100 / totalAmount).toFixed(2)}%)</Typography>
                </Box>
                <Box component="span" display="flex" flexDirection="column">
                    <Typography variant="caption" align="center">Total</Typography>
                    <Typography variant="subtitle2" align="center"
                                className={totalProfitOrLossAmount > 0 ? classes.profit : classes.loss}>
                        {totalProfitOrLossAmount?.toLocaleString(DEFAULT_LOCALE, INR_CURRENCY_STYLE)}</Typography>
                    <Typography variant="subtitle2"
                                className={totalProfitOrLossAmount > 0 ? classes.profit : classes.loss} align="center">
                        ({(totalProfitOrLossAmount * 100 / totalAmount).toFixed(2)}%)</Typography>
                </Box>
            </Box>
        </Paper>
    )
}

export default HoldingSummary